// Embed-mode helpers. When cb2 is loaded inside an iframe (e.g. from IQ),
// we skip the normal Auth0 SPA flow and accept a Bearer token from the
// parent window via postMessage.
//
// Detection: the URL must start with `/embed/` (not `?embed=1`) so that the
// Auth0Provider isn't even mounted for embedded views — third-party cookies
// can't be relied on inside iframes anymore, so a hidden silent-auth attempt
// would just redirect-loop in QA.

export const isEmbed = () => {
  const path = window?.location?.pathname
  return typeof path === 'string' && path.startsWith('/embed/')
}

// Origins allowed to embed cb2 AND to send us auth tokens via postMessage.
// Anything outside this list is ignored (even if the iframe loads, we won't
// trust the message). Keep this list narrow.
export const ALLOWED_PARENT_ORIGINS = [
  'https://iq.centerbase.us',
  'https://iq.centerbase.ai',
  'https://iq-qa.centerbase.us',
  'https://narratives.centerbase.com',
  // Local dev for the IQ side
  'http://localhost:5173',
  'http://localhost:5174',
  'http://localhost:51053',
]

export const isAllowedParentOrigin = (origin) => {
  if (!origin) return false
  return ALLOWED_PARENT_ORIGINS.includes(origin)
}
